module.exports = __webpack_public_path__ + "img/Scott Stadthagen.3d07d0bb.jpg";